import Swiper from 'swiper';
import { Navigation, A11y, Autoplay, Thumbs } from 'swiper/modules';

function sliderThumbs(){
    document.querySelectorAll('.slider-thumbs:not(.slider-thumbs_vertical)').forEach(slider => {
        const selector = '.' + slider.classList.value.trim().replace(/\s+/g, '.');

        const swiperThumbs = document.querySelector(selector + ' .slider-thumbs__carousel .swiper')
            ? new Swiper(`${selector} .slider-thumbs__carousel .swiper`, {
                spaceBetween: 10,
                slidesPerView: 4,
                watchSlidesProgress: true,
                centerInsufficientSlides: true
            })
            : null;

        const swiperMain = new Swiper(selector + ' .slider-thumbs__main .swiper', {
            modules: [Navigation, A11y, Autoplay, Thumbs],
            rewind: true,
            autoplay: slider.classList.contains('slider-thumbs_product')
                ? false
                : {
                    delay: 9000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false
                },
            navigation: {
                nextEl: selector + ' .swiper-button-next-custom',
                prevEl: selector + ' .swiper-button-prev-custom',
            },
            a11y: {
                prevSlideMessage: 'Предыдущий слайд',
                nextSlideMessage: 'Следующий слайд',
                firstSlideMessage: 'Это первый слайд',
                lastSlideMessage: 'Это последний слайд',
                paginationBulletMessage: 'К слайду №{{index}}'
            },
            thumbs: {
                swiper: swiperThumbs,
            }
        });

    });
}

export default sliderThumbs;